import { render, staticRenderFns } from "./SinosLegenda.vue?vue&type=template&id=527b4e42&scoped=true&"
import script from "./SinosLegenda.vue?vue&type=script&lang=js&"
export * from "./SinosLegenda.vue?vue&type=script&lang=js&"
import style0 from "./SinosLegenda.vue?vue&type=style&index=0&id=527b4e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b4e42",
  null
  
)

export default component.exports